module.exports = __webpack_public_path__ + "src/img/down.ac413289.svg";